export const newUserPointBack = {
  /** マイページの進捗カード */
  summaryCard: {
    /** カード全体の見出し（開催中バッジ + 見出し） */
    headingBadge: "開催中",
    heading: "Wポイントバックキャンペーン",
    title: "使った分だけポイント還元！",
    detailLink: "詳細",
    pointUnit: "pt",
    achievedLabel: "達成！",
    /** 同じカード内に出す、秋のポイントバックの進捗 */
    autumn: {
      title: "対象の子と3分以上のビデオをしよう！",
      detailLink: "詳細",
      countUnit: "人",
    },
  },
} as const;
